
import React from "react";
import ProductInfo from "./ProductInfo";
import { MdOutlineFileDownload } from "react-icons/md";
import { useTranslation } from 'react-i18next';

/* ---------------------------------------------------------------------------- */

import {
  DownloadButton,
  DownloadList,
  ProductDescription,
  ProductDocument,
  ProductImage,
  ProductSection,
} from "./StyledComponents";

/* ----------------------------------------------------------------------------
 *          IMAGES
 * --------------------------------------------------------------------------- */

import TryggVardagTavlaBild from "../../../../data/images/products/Trygg Vardag Tavla/Huvudbild_tavla.png";


/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES
 * --------------------------------------------------------------------------- */

import TryggVardagRekond from "../../../../data/downloads/Trygg_vardag_rekonditionering_nya.pdf";
import TryggVardagTavlaBordstativ from "../../../../data/downloads/Trygg-vardag-tavla-bordstativ.pdf";
import TryggVardagTavlaManual from "../../../../data/downloads/Manual_trygg-vardag_tavla_nya.pdf";
import TryggVardagTavlaStartaUpp from "../../../../data/downloads/Starta_upp_trygg-vardag_tavla_nya.pdf";
import TryggVardagTavlaSnabbguide from "../../../../data/downloads/Snabbguide_trygg-vardag_tavla_nya.pdf";
import TryggVardagTavlaReferensmanual from "../../../../data/downloads/Referensmanual-trygg-vardag_tavla_och_surfplatta.pdf";


/* ----------------------------------------------------------------------------
 *          DOWNLOAD FILES - OLD
 * --------------------------------------------------------------------------- */

import TryggVardagTavlaManual_gammal from "../../../../data/downloads/Manual-trygg-vardag-tavla.pdf";
import TryggVardagTavlaStartaUpp_gammal from "../../../../data/downloads/Starta-upp-trygg-vardag-tavla.pdf";
import TryggVardagTavlaSnabbguide_gammal from "../../../../data/downloads/Snabbguide-trygg-vardag-tavla.pdf";


/* ============================================================================ */
/*          PORT | KOMM - function
/* ============================================================================ */


const TryggVardagTavla = () => {
  
  const { t } = useTranslation("products/tryggvardagtavla"); 

  return (
    <main className="product container">
      <ProductSection>
        <h1>{t('h1_tryggvardagtavla')}</h1>
        <ProductImage src={TryggVardagTavlaBild} alt="" />

        <ProductDescription>
          <p>{t('p1_tryggvardagtavla')}</p>
          <p>{t('p2_tryggvardagtavla')}</p>
          <p>{t('p3_tryggvardagtavla')}</p>
        </ProductDescription>
    
         <ProductInfo titel={t('dokument_tryggvardagtavla')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardagtavla')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagTavlaManual} download="Användarmanual-trygg-vardag-tavla.pdf">
                    <span>Användarmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>     
                        <DownloadButton>
                  <a href={TryggVardagTavlaReferensmanual} download="Referensmanual-trygg-vardag-tavla.pdf">
                    <span>Referensmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>             
                <DownloadButton>
                  <a href={TryggVardagTavlaStartaUpp} download="Starta-upp-trygg-vardag-tavla.pdf">
                    <span>Starta upp Manual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagTavlaSnabbguide} download="Snabbguide-trygg-vardag-tavla.pdf">
                    <span>Snabbguide</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagTavlaBordstativ} download="Bord/Väggstativ-trygg-vardag-tavla.pdf">
                    <span>Bord/Väggstativ</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagRekond} download="manual-trygg-rekonditionering.pdf">
                    <span>Rekonditionersingsmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>

        <ProductInfo titel={t('dokument_tryggvardagtavla_gammal')}>
          <ProductDocument>
            <ul>
              <p>{t('laddaner_tryggvardagtavla')}</p>

              <DownloadList>
                <DownloadButton>
                  <a href={TryggVardagTavlaManual_gammal} download="Användarmanual-trygg-vardag-tavla-äldre-version.pdf">
                    <span>Användarmanual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>                
                <DownloadButton>
                  <a href={TryggVardagTavlaStartaUpp_gammal} download="Starta-upp-trygg-vardag-tavla-äldre-version.pdf">
                    <span>Starta upp Manual</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
                <DownloadButton>
                  <a href={TryggVardagTavlaSnabbguide_gammal} download="Snabbguide-trygg-vardag-tavla-äldre-version.pdf">
                    <span>Snabbguide</span>
                    <MdOutlineFileDownload />
                  </a>
                </DownloadButton>
              </DownloadList>
            </ul>
          </ProductDocument>
        </ProductInfo>
        
      </ProductSection>
    </main>
  );
};

export default TryggVardagTavla;
